import { IOrderSystemNotification, IResponseOrderSystemNotification } from '../types';

export const orderSystemNotificationCast = (data: IResponseOrderSystemNotification): IOrderSystemNotification => {
  return {
    otp: { en: data.otp_verification_en, ar: data.otp_verification_ar },
    address: { en: data.address_update_en, ar: data.address_update_ar },
    refund: { en: data.refund_message_en, ar: data.refund_message_ar },
  };
};

export const getOrderSystemNotificationParams = (data: IOrderSystemNotification) => {
  return {
    otp_verification_en: data.otp.en,
    otp_verification_ar: data.otp.ar,
    // address_update_en: data.address.en,
    // address_update_ar: data.address.ar,
    address_update_en: undefined,
    address_update_ar: undefined,
    refund_message_en: data.refund.en,
    refund_message_ar: data.refund.ar,
  };
};
